import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <section className="section">
      <div className="container">
        <div className="card error-page">
          <div className="error-header">
            <span className="error-code">404</span>
            <h1 className="error-title">Page not found</h1>
            <p className="error-subtitle muted">
              The page you're looking for doesn't exist or may have been moved.
            </p>
          </div>

          <div className="error-actions">
            <Link to="/" className="button button-primary">
              Go back home
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
